import { IKeyValue } from "@/api/AppApi/services/filters/interfaces/IGetFilters";
import { IProductChildMinimizedData } from "@/app/components/pages-components/product-details-page/details-belpers/product-attributes/helpers/interfaces";

export const findChildernImages = (
  children: IProductChildMinimizedData[],
  filter: IKeyValue[],
) => {
  const fillterImages = filter.map((f) => {
    const child = children.find((child) =>
      child.attribute_ids.includes(+f.key),
    );
    return { ...f, image_url: child?.images?.[0]?.image_url ?? "" };
  });
  return fillterImages;
};
